import type { HttpGet } from '@/shared/infra/http'
import type {
  LoadEffectiveAllowedHuntTypes,
  LoadEffectiveAllowedHuntTypesResult,
} from '@/shared/domain'

export class EdgeLoadEffectiveAllowedHuntTypesRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadEffectiveAllowedHuntTypes = async (params) => {
    const query = `?orgId=${params.orgId}&orgType=${params.orgType}`
    return this.httpClient.get<LoadEffectiveAllowedHuntTypesResult>({
      url: `/org-settings/allowed-hunt-types/effective${query}`,
    })
  }
}
